import {Injectable} from '@angular/core';
import {LOCALE_MAPPER} from '../constants/Currency.constants';

declare var numeral: any;

@Injectable({
  providedIn: 'root'
})
export class NumeralService {

    constructor() {
        this.registerLocales();
    }

    public format(format: string, value: any): string {
        if (numeral.locale() == 'id-id'){
            numeral.locale('en');
            const val = numeral(numeral(value).value());
            numeral.locale('id-id');
            return val.format(format);
        }else {
            return numeral(numeral(value).value()).format(format);
        }
    }

    public formatNumber(format: string, value: any): string {
        if (numeral.locale() == 'id-id'){
            numeral.locale('en');
            const val = numeral(numeral(value).value());
            const formattedNumber = val.format(format);
            numeral.locale('id-id');
            return formattedNumber;
        }else {
            return numeral(numeral(value).value()).format(format);
        }
    }

    public value(value: any) {
        if (numeral.locale() == 'id-id'){
            if (value && typeof value === 'string' && (value.indexOf(',') != -1 || value.indexOf('Rp') != -1)){
                const val = numeral(value).value();
                numeral.locale('id-id');
                return val;
            }else {
                numeral.locale('en');
                const val = numeral(value).value();
                numeral.locale('id-id');
                return val;
            }
        }else {
            return numeral(value).value();
        }
    }

    public getNumberValue(value: any) {
        if (numeral.locale() == 'id-id'){
            numeral.locale('en');
            const val = numeral(value).value();
            numeral.locale('id-id');
            return val;
        }else {
            return numeral(value).value();
        }
    }

    public switchLocale(locale: string) {
        const _locale = LOCALE_MAPPER[locale.toLowerCase()];
        numeral.locale(_locale ? _locale : locale.toLowerCase());
    }

    registerLocales() {

        try {
            numeral.register('locale', 'ind', {
                delimiters: {
                    thousands: ',',
                    decimal: '.'
                },
                abbreviations: {
                    thousand: 'k',
                    million: 'm',
                    billion: 'b',
                    trillion: 't'
                },
                ordinal(number) {
                    const b = number % 10;
                    return (~~(number % 100 / 10) === 1) ? 'th' :
                        (b === 1) ? 'st' :
                            (b === 2) ? 'nd' :
                                (b === 3) ? 'rd' : 'th';
                },
                currency: {
                    symbol: '₹'
                }
            });
        } catch (e) {

        }
        try{
            numeral.register('locale', 'en-gb', {
                delimiters: {
                    thousands: ',',
                    decimal: '.'
                },
                abbreviations: {
                    thousand: 'k',
                    million: 'm',
                    billion: 'b',
                    trillion: 't'
                },
                ordinal(number) {
                    const b = number % 10;
                    return (~~ (number % 100 / 10) === 1) ? 'th' :
                        (b === 1) ? 'st' :
                            (b === 2) ? 'nd' :
                                (b === 3) ? 'rd' : 'th';
                },
                currency: {
                    symbol: '£'
                }
            });
        } catch (e){

        }
        try{
            numeral.register('locale', 'en-eur', {
                delimiters: {
                    thousands: ',',
                    decimal: '.'
                },
                abbreviations: {
                    thousand: 'k',
                    million: 'm',
                    billion: 'b',
                    trillion: 't'
                },
                ordinal(number) {
                    const b = number % 10;
                    return (~~ (number % 100 / 10) === 1) ? 'th' :
                        (b === 1) ? 'st' :
                            (b === 2) ? 'nd' :
                                (b === 3) ? 'rd' : 'th';
                },
                currency: {
                    symbol: '€'
                }
            });
        } catch (e) {

        }

        try{
            numeral.register('locale', 'en-au', {
                delimiters: {
                    thousands: ',',
                    decimal: '.'
                },
                abbreviations: {
                    thousand: 'k',
                    million: 'm',
                    billion: 'b',
                    trillion: 't'
                },
                ordinal(number) {
                    const b = number % 10;
                    return (~~ (number % 100 / 10) === 1) ? 'th' :
                        (b === 1) ? 'st' :
                            (b === 2) ? 'nd' :
                                (b === 3) ? 'rd' : 'th';
                },
                currency: {
                    symbol: '$'
                }
            });
        } catch (e){

        }

        try{
            numeral.register('locale', 'id-ID', {
                delimiters: {
                    thousands: '.',
                    decimal: ','
                },
                abbreviations: {
                    thousand: 'k',
                    million: 'm',
                    billion: 'b',
                    trillion: 't'
                },
                ordinal(number) {
                    const b = number % 10;
                    return (~~ (number % 100 / 10) === 1) ? 'th' :
                        (b === 1) ? 'st' :
                            (b === 2) ? 'nd' :
                                (b === 3) ? 'rd' : 'th';
                },
                format: '$0.0,00',
                currency: {
                    symbol: 'Rp'
                }
            });
        } catch (e){

        }

        try{
            numeral.register('locale', 'xof', {
                delimiters: {
                    thousands: ',',
                    decimal: '.'
                },
                abbreviations: {
                    thousand: 'k',
                    million: 'm',
                    billion: 'b',
                    trillion: 't'
                },
                ordinal(number) {
                    const b = number % 10;
                    return (~~ (number % 100 / 10) === 1) ? 'th' :
                        (b === 1) ? 'st' :
                            (b === 2) ? 'nd' :
                                (b === 3) ? 'rd' : 'th';
                },
                format: '$0,0.00',
                currency: {
                    symbol: 'Xof'
                }
            });
        } catch (e){

        }

        try{
            numeral.register('locale', 'cfa', {
                delimiters: {
                    thousands: ',',
                    decimal: '.'
                },
                abbreviations: {
                    thousand: 'k',
                    million: 'm',
                    billion: 'b',
                    trillion: 't'
                },
                ordinal(number) {
                    const b = number % 10;
                    return (~~ (number % 100 / 10) === 1) ? 'th' :
                        (b === 1) ? 'st' :
                            (b === 2) ? 'nd' :
                                (b === 3) ? 'rd' : 'th';
                },
                format: '$0,0.00',
                currency: {
                    symbol: 'Cfa'
                }
            });
        } catch (e){

        }

        try{
            numeral.register('locale', 'en-ca', {
                delimiters: {
                    thousands: ',',
                    decimal: '.'
                },
                abbreviations: {
                    thousand: 'k',
                    million: 'm',
                    billion: 'b',
                    trillion: 't'
                },
                ordinal(number) {
                    const b = number % 10;
                    return (~~ (number % 100 / 10) === 1) ? 'th' :
                        (b === 1) ? 'st' :
                            (b === 2) ? 'nd' :
                                (b === 3) ? 'rd' : 'th';
                },
                format: '$0,0.00',
                currency: {
                    symbol: '$'
                }
            });
        } catch (e){

        }

    }


}
